/* eslint-disable react/prop-types */
import React from "react";

const BrowserWalletPay = (props) => {
    return (<button 
        className="browser-pay-button pay-button--two-lined"
        onClick={props.onClick}>
                <div className="slide-in">
                    <span> Pay With</span> 
                    <span className="payment-method">
                        <i className="fa fa-globe" /> Browser Wallet
                    </span>
                </div> 
        </button>);
};

export default BrowserWalletPay;


// WEBPACK FOOTER //
// ./src/components/checkout/BrowserWalletPay.js